import { Data, NodeData, NodeType } from '../types'

// Single source of truth for "is this node a circle or a leaf role".
// Mirrors the padding test applied in core/layout.ts (packData), so the visual
// treatment matches how the layout already sizes each node.

// A circle: a Circle-typed node that contains at least one sub-circle.
export function hasSubCircles(node: NodeData): boolean {
  return dataHasSubCircles(node.data)
}

// The same test on the data, before any layout (layoutLinkedCircles)
export function dataHasSubCircles(data: Data): boolean {
  return (
    data.type === NodeType.Circle &&
    !!data.children?.some((c) => c.type === NodeType.Circle)
  )
}

// A leaf role: a Circle-typed node with no sub-circle child (only members, or
// an invited-circle link whose single child is a MembersCircle). See
// hasSubCircles.
export function isRoleNode(node: NodeData): boolean {
  return node.data.type === NodeType.Circle && !hasSubCircles(node)
}
